"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const roomCreateStore_1 = require("@/room/room_create/roomCreateStore");
const functions_1 = require("@/common/functions");
const CircularProgress_1 = __importDefault(require("@mui/material/CircularProgress"));
function default_1() {
    const dispatch = (0, react_redux_1.useDispatch)();
    (0, react_1.useLayoutEffect)(() => {
        dispatch((0, roomCreateStore_1.getRoomData)('clone'));
        window.setTimeout(() => {
            window.onbeforeunload = null;
            (0, functions_1.replaceToMain)();
        }, 24 * 60 * 60 * 1000);
    }, []);
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ css: {
            display: 'flex',
            justifyContent: 'center',
            padding: '30vh 0',
        } }, { children: (0, jsx_runtime_1.jsx)(CircularProgress_1.default, { size: 30, color: "secondary", thickness: 6 }) })));
}
exports.default = default_1;
